// export default {
//     install(Vue, options) {
//         Vue.prototype.$confirm = function () {

//         }
//     }
// }




export default {
    async install(Vue) {
        let callBack = null;
        await Vue.mixin({
            created() {
                if(this.$options.name === "DIALOVA_DIALOG_COMPONENT")
                    callBack = this.openDialog;
            }
        })
        Vue.prototype.$dialova = callBack;
    }
};